{
  "level": "field5",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:field5",
    "objects": "AREAS.E3:field5.e3",
    "mesh": "TREES.E3:field5.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2799.999755859375,
      "bbox_min": [
        -2799.999755859375,
        -4372.7998046875,
        1092.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4370.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: field5",
      "entity_class": "CSlidingDoor",
      "piece_name": "field5",
      "offset": 437,
      "centroid": [
        1160.0,
        1137.7000122070312,
        127.77089881896973
      ],
      "bbox_min": [
        1160.0,
        1105.4000244140625,
        95.29412078857422
      ],
      "bbox_max": [
        1160.0,
        1170.0,
        160.0
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 64.5999755859375,
        "height_z": 64.70587921142578,
        "door_width": 64.5999755859375,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          1160.0,
          1170.0,
          160.0
        ],
        [
          1160.0,
          1170.0,
          160.0
        ],
        [
          1160.0,
          1105.4000244140625,
          95.78947448730469
        ],
        [
          1160.0,
          1105.4000244140625,
          95.78947448730469
        ],
        [
          1160.0,
          1170.0,
          95.29412078857422
        ],
        [
          1160.0,
          1170.0,
          95.29412078857422
        ],
        [
          1160.0,
          1105.4000244140625,
          160.0
        ],
        [
          1160.0,
          1105.4000244140625,
          160.0
        ]
      ],
      "plane_distance": -1160.0
    }
  ],
  "tutorial_messages": []
}